// bill_subsystem_v1: layout shell for bill app (sidebar + outlet)
import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileText, Package, Users, UserCog, LogOut, Radio, KeyRound, Wallet, BarChart3, PieChart, Users2, Handshake, Calculator, Landmark } from 'lucide-react'; /* business_budget_v1 fe: Calculator icon */ /* partner_v1 nav: Handshake icon */ /* payroll_v1: Users2 for payroll nav */ /* finance_dashboard_v1: PieChart for nav */ /* bill_channels_v1 */ /* change_pw_ui_v1 */ /* autofinance_ui_v1 */
import API from './api';
import BillChangePasswordModal from './BillChangePasswordModal'; /* change_pw_ui_v1 */

/* billnav_perm_v1: เพิ่ม res เพื่อกรองตามสิทธิ์ */
const NAV = [ /* bill_smart_landing_v1: reordered + grouped */
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', exact: true, res: 'dashboard', group: 'การเงิน' },
  { to: '/finance-dashboard', icon: PieChart, label: 'หน้าหลักการเงิน', res: 'summary', group: 'การเงิน' }, /* finance_dashboard_v1 nav */
  { to: '/finance', icon: Wallet, label: 'การเงิน', res: 'transactions', group: 'การเงิน' },
  { to: '/finance-summary', icon: BarChart3, label: 'สรุปการเงิน', res: 'summary', group: 'การเงิน' },
  { to: '/payroll', icon: Users2, label: 'เงินเดือน', res: 'payroll', group: 'การเงิน' }, /* payroll_v1 nav */
  { to: '/partners', icon: Handshake, label: 'พาร์ทเนอร์', res: 'partners', group: 'การเงิน' }, /* partner_v1 nav */
  { to: '/budget', icon: Calculator, label: 'งบธุรกิจ', res: 'budget', group: 'การเงิน' }, /* business_budget_v1 fe nav */
  { to: '/invoices', icon: FileText, label: 'ใบแจ้งหนี้', res: 'invoices', group: 'ระบบบิล' },
  { to: '/customers', icon: Users, label: 'ลูกค้า', res: 'customers', group: 'ระบบบิล' },
  { to: '/products', icon: Package, label: 'สินค้า', res: 'products', group: 'ระบบบิล' },
  { to: '/bank-accounts', icon: Landmark, label: 'บัญชี/พร้อมเพย์', res: 'invoices', group: 'ระบบบิล' }, /* bank_promptpay_v1 */
  { to: '/channels', icon: Radio, label: 'ช่องทาง', res: 'channels', group: 'ทั่วไป' },
];

const OWNER_NAV = [
  { to: '/users', icon: UserCog, label: 'ผู้ใช้งาน', group: 'ทั่วไป' },
];

export default function BillLayout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(function () {
    try { return JSON.parse(localStorage.getItem('bill_user') || 'null'); }
    catch (e) { return null; }
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showPw, setShowPw] = useState(false); /* change_pw_ui_v1 */
  const [myPerms, setMyPerms] = useState(null); /* billnav_perm_v1 */
  const [billLic, setBillLic] = useState(null); /* bill_expiry_fe_v1 */
  useEffect(function () { API.get('/api/finance/permissions/my').then(function (r) { setMyPerms(r.data); }).catch(function () { setMyPerms({ is_owner: false, perms: {} }); }); }, []);
  useEffect(function () { API.get('/api/bill/dashboard/license').then(function (r) { setBillLic(r.data); }).catch(function () {}); }, []); /* bill_expiry_fe_v1 */

  useEffect(function () {
    var onResize = function () { setIsMobile(window.innerWidth < 768); };
    window.addEventListener('resize', onResize);
    return function () { window.removeEventListener('resize', onResize); };
  }, []);

  useEffect(function () {
    API.get('/api/bill/auth/me').then(function (r) {
      if (r.data && r.data.user) {
        setUser(r.data.user);
        try { localStorage.setItem('bill_user', JSON.stringify(r.data.user)); } catch (e) {}
      }
    }).catch(function () {});
  }, []);

  const handleLogout = async function () {
    try { await API.post('/api/bill/auth/logout'); } catch (e) {}
    localStorage.removeItem('bill_token');
    localStorage.removeItem('bill_user');
    window.location.href = '/';
  };

  const isOwner = user && user.bill_role === 'owner';
  /* billnav_perm_v1: owner เห็นหมด; admin เห็นเฉพาะเมนูที่มีสิทธิ์ view */
  var visibleNav = (myPerms && !myPerms.is_owner) ? NAV.filter(function (it) { return it.res && myPerms.perms[it.res] && myPerms.perms[it.res].view; }) : NAV;
  const navItems = isOwner ? visibleNav.concat(OWNER_NAV) : visibleNav;

  const linkStyle = function (isActive) {
    return {
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '10px 14px', borderRadius: 8,
      color: isActive ? '#10b981' : '#475569',
      background: isActive ? '#ecfdf5' : 'transparent',
      fontWeight: isActive ? 600 : 400,
      fontSize: 14, textDecoration: 'none',
    };
  };

  /* bill_expiry_always_v1: แสดงวันหมดอายุบิลตลอดเวลา (เขียว=ไกล, เหลือง<=14, ส้ม<=3, แดง=หมด) */
  var renderExpiryBanner = function () {
    if (!billLic || billLic.expires_at == null) return null;
    var d = billLic.days_left;
    var expired = d != null && d <= 0;
    var near = d != null && d <= 3;
    var soon = d != null && d <= 14;
    var bg = expired ? '#fef2f2' : (near ? '#fff7ed' : (soon ? '#fefce8' : '#f0fdf4'));
    var brd = expired ? '#fecaca' : (near ? '#fed7aa' : (soon ? '#fde68a' : '#bbf7d0'));
    var fg = expired ? '#b91c1c' : (near ? '#c2410c' : (soon ? '#a16207' : '#15803d'));
    var dateStr = '';
    try { dateStr = new Date(billLic.expires_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) {}
    var msg = expired
      ? ('ระบบบิลหมดอายุแล้ว (' + dateStr + ')')
      : ('บิลหมดอายุ: ' + dateStr + (d != null ? ' · เหลือ ' + d + ' วัน' : ''));
    var showContact = expired || soon;
    return (
      <div style={{ background: bg, border: '1px solid ' + brd, color: fg, borderRadius: 10, padding: '8px 14px', marginBottom: 14, fontSize: 13 }}>
        <b>{(expired || soon) ? '⏰' : '🧾'} {msg}</b>
        {showContact ? <span> · ติดต่อต่ออายุที่แอดมิน <b>@mawin1991</b></span> : null}
      </div>
    );
  };

  if (isMobile) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
        <div style={{ background: 'white', padding: '12px 16px', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 20 }}>🧾</span>
            <strong style={{ fontSize: 15 }}>{(user && user.tenant_name) || 'Bill'}</strong>
          </div>
          <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}>
<KeyRound size={18} style={{ marginRight: 14, cursor: 'pointer' }} onClick={function () { setShowPw(true); }} />
            <LogOut size={18} />
          </button>
        </div>
        <div style={{ padding: 16, paddingBottom: 80 }}>
          {renderExpiryBanner()}
          <Outlet context={{ user: user, myPerms: myPerms }} />
        </div>
        {showPw && <BillChangePasswordModal onClose={function () { setShowPw(false); }} />}
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white', borderTop: '1px solid #e2e8f0', display: 'flex', padding: '8px 4px', zIndex: 10 }}>
          {navItems.map(function (item) {
            const Icon = item.icon;
            return (
              <NavLink key={item.to} to={item.to} end={!!item.exact} style={function (state) {
                return {
                  flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                  padding: '6px 4px', textDecoration: 'none', minHeight: 50,
                  color: state.isActive ? '#10b981' : '#94a3b8', fontSize: 11,
                };
              }}>
                <Icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
      <aside style={{ width: 240, background: 'white', borderRight: '1px solid #e2e8f0', padding: '20px 16px', position: 'sticky', top: 0, height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ marginBottom: 24, padding: '0 6px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <span style={{ fontSize: 26 }}>🧾</span>
            <strong style={{ fontSize: 18, color: '#0f172a' }}>ระบบบิล</strong>
          </div>
          <div style={{ fontSize: 12, color: '#94a3b8' }}>{(user && user.tenant_name) || ''}</div>
        </div>
        <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {(function () { /* bill_smart_landing_v1: group headers */
            var lastG = null; var out = [];
            navItems.forEach(function (item) {
              if (item.group && item.group !== lastG) {
                out.push(<div key={'g-' + item.group} style={{ padding: '14px 14px 4px', fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 0.5 }}>{item.group}</div>);
                lastG = item.group;
              }
              var Icon = item.icon;
              out.push(<NavLink key={item.to} to={item.to} end={!!item.exact} style={function (state) { return linkStyle(state.isActive); }}><Icon size={18} /><span>{item.label}</span></NavLink>);
            });
            return out;
          })()}
        </nav>
        <div style={{ paddingTop: 16, borderTop: '1px solid #f1f5f9' }}>
          <div style={{ padding: '8px 14px', fontSize: 12, color: '#64748b' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{(user && user.name) || '...'}</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>{(user && user.bill_role) || ''}</div>
          </div>
          <button onClick={function () { setShowPw(true); }} style={{ width: '100%', background: 'none', border: 'none', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, color: '#475569', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}>
            <KeyRound size={16} />
            <span>เปลี่ยนรหัสผ่าน</span>
          </button>
          <button onClick={handleLogout} style={{ width: '100%', background: 'none', border: 'none', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, color: '#ef4444', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}>
            <LogOut size={16} />
            <span>ออกจากระบบ</span>
          </button>
        </div>
      {showPw && <BillChangePasswordModal onClose={function () { setShowPw(false); }} />}
      </aside>
      <main style={{ flex: 1, padding: 24, overflowY: 'auto' }}>
        {renderExpiryBanner()}
        <Outlet context={{ user: user, myPerms: myPerms }} />
      </main>
    </div>
  );
}
